export const socialsData = {
  github: "https://github.com/mjgupta9135",
  facebook: "https://m.facebook.com/mrityunjaymkg/",
  linkedIn: "https://www.linkedin.com/in/mjgupta91/",
  instagram: "https://www.instagram.com/mjgupta0/",
  leetCode: "https://leetcode.com/u/mjgupta9135/",
  geeksforGeeks: "https://auth.geeksforgeeks.org/user/mjgupta0/profile",
};
